<aw-contract-dialog-status-transition [contract]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-contract-dialog-status-transition>